import { createAddSmartFeedActivityUrl } from "src/consts/urls";
import { useMutation } from "src/hooks/react-query/use-mutation";
import { useRouterLocale } from "src/utils/router/use-router-locale";

export enum EnumSmartFeedActivity {
    SmartFeedItemLiked = 2104,
    SmartFeedItemShared = 2105,
    SmartFeedItemClicked = 2106,
}

interface IFeedActivityRequest {
    itemId: string;
    type: EnumSmartFeedActivity;
    parameter?: string;
}

export function useFeedActivityMutation() {
    const { language, country } = useRouterLocale();

    const { mutatePromise } = useMutation<void, unknown, IFeedActivityRequest>(createAddSmartFeedActivityUrl(language, country));

    return mutatePromise;
}
